declare var Highcharts: any;

import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DashboardService } from '../../../dashboard/services/dashboard.service';
import { Utils } from '../../Utils'
@Component({
  selector: 'app-display-eia-heatmap',
  templateUrl: './display-eia-heatmap.component.html',
  styleUrls: ['./display-eia-heatmap.component.css']
})
export class DisplayEiaHeatmapComponent implements OnInit, OnDestroy {
  subscription: any;
  theData: any;
  heatMapData = [];
  heatMapTopLabels = [];
  //heatMapColors = ['#003c56','#006997','#0096d7','#4db6e3','#99d5ef','#AFAFAF','#e5c799','#d19d69','#bd732a','#84511d','#4c2e11']; //used in the view to render legend color boxes
  // heatMapColors = [
  //   {color : '#003c56', label : "<= -20" , topLabel : '°F below normal'},
  //   {color : '#006997', label : "<= -15" },
  //   {color : '#0096d7', label : "<= -10" },
  //   {color : '#4db6e3', label : "<= -5" },
  //   {color : '#99d5ef', label : "< 0" },
  //   {color : '#AFAFAF', label : "0" , topLabel : 'normal' },
  //   {color : '#e5c799', label : "< 5" },
  //   {color : '#d19d69', label : "< 10" },
  //   {color : '#bd732a', label : "< 15" },
  //   {color : '#84511d', label : "< 20" },
  //   {color : '#4c2e11', label : ">= 20" , topLabel : '°F above normal' }
  // ];
    heatMapColors = [
        {color : '#003c56', label : "<= -20" , topLabel : '°F below normal', upper: "<= -20", lower: ""},
        {color : '#006997', label : "-19 - -15" ,lower: "-19", upper: "-15" },
        {color : '#0096d7', label : "-14 to -10",lower: "-14", upper: "-10" },
        {color : '#4db6e3', label : "-9 to -5",lower: "-9", upper: "-5" },
        {color : '#99d5ef', label : "-4 to -1" ,lower: "-4", upper: "-1"},
        {color : '#AFAFAF', label : "0" , topLabel : 'normal', lower: '', upper: '0' },
        {color : '#e5c799', label : "1 to 4" ,lower: "1", upper: "4"},
        {color : '#d19d69', label : "5 to 9" ,lower: "5", upper: "9"},
        {color : '#bd732a', label : "10 to 14" ,lower: "10", upper: "14"},
        {color : '#84511d', label : "15 to 19" ,lower: "15", upper: "19"},
        {color : '#4c2e11', label : ">= 20" , topLabel : '°F above normal' ,lower: ">= 20", upper: ""}
    ];
  lower48Data = [];
  heatMapOrder: any = ['East', 'Midwest', 'South Central', 'Mountain', 'Pacific','Lower 48'];
  displayRegionsArray: any = [];
  constructor(public dashboardService: DashboardService) { }

  ngOnInit() {
    var controller = this;
    this.subscription = this.dashboardService.getHeatMapData().subscribe(
      json =>{
        var endDate = controller.changeDateFormat(json.endDate); //change endDate to a format acceptable by firefox (data as mmm dd yy)

          controller.heatMapOrder.forEach(function(e){
            let newRegion1:any = {};
            newRegion1.name = e;
            newRegion1.data = [];

            for (let [date,dataItem] of Object.entries(json.data[e].data)) {
                let newDataItem1:any = {};
                newDataItem1 = dataItem;
                newDataItem1.date = date;
                newRegion1.data.push(newDataItem1);
            }
            controller.orderByDate(newRegion1.data);
            controller.heatMapData.push(newRegion1);
          });


        controller.heatMapData[0].data.forEach(function(element,index){
            var plotDate = new Date(endDate);
            plotDate.setDate(endDate.getDate()-index);
            controller.heatMapTopLabels.push(Utils.dateAsMMMDD(plotDate));
        });

        this.heatMapTopLabels.reverse();
      }
    );
  }

  // used to order dates ascending
  orderByDate(arr){
    let dateA: any;
    let dateB: any;
    arr.sort(function(a,b){
      dateA = new Date(a.date);
      dateB = new Date(b.date);
      return dateA - dateB;
    });
  }

  //used in view to render heatmap data colors
  getHeatmapDataColor(num){

    var color;
    switch(true){
      case (num == null):
        color = 'white';
        break;
      case (num >= 20):
        color = '#4c2e11';
        break;
      case (num >= 15):
        color = '#84511d';
        break;
      case (num >=10):
        color = '#bd732a';
        break;
      case (num >=5):
        color = '#d19d69';
        break;
      case (num >0):
        color = '#e5c7aa';
        break;
      case (num == 0):
        color = '#AFAFAF';
        break;
      case (num <= -20):
        color = '#003c56';
        break;
      case (num<= -15):
        color = '#006997';
        break;
      case (num <= -10):
        color = '#0096d7';
        break;
      case (num <=-5):
        color = '#4db6e3';
        break;
      case (num <0):
        color = '#99d5ef';
        break;
      default:
        color = 'white';
        break;

    }

    return color;
  }

  getHeatmapTextColor(num) {
    let color;

    switch (true) {
      case (num >= 20):
        color = 'white';
        break;
      case (num <= -20):
        color = 'white';
        break;
      default:
        color = 'black';
        break;

    }

    return color;
  }

  changeDateFormat(date){
    var splitDate = date.split('-');
    var dateString = Utils.monthsInYearNumbers[splitDate[1].toLowerCase()] + "/" + splitDate[0] + "/" + splitDate[2];
    var newDate = new Date(dateString);
    return newDate;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/display-eia-heatmap/display-eia-heatmap.component.ts